exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.region-store-pane[data-v-bbe552d0]{\n  padding: 10px;\n  border: 1px solid #eee;\n  border-radius: 5px;\n  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n}\n", ""]);

// exports
